'use client';

import { Button, Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { WelcomePageWrapper } from '@/app/(blank-layout-pages)/welcomePageWrapper';
import { DomainInput } from '@/components/form/domainInput';
import { Link } from '@/components/shared/link';
import { isValidTenant } from '@/contexts/environment';

export const LoginV2DomainPage = () => {
  const [domain, setDomain] = useState('');
  const [focused, setFocused] = useState(true);

  const onLogin = (value: string) => {
    if (!isValidTenant(value)) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    params.set('domain', value);
    // A document load, not a client-side push: /login resolves the domain on the
    // server and redirects to that tenant's own subdomain (or the backend's
    // hosted UI), and the client router cannot follow a cross-origin redirect.
    // eslint-disable-next-line @next/next/no-location-assign-relative-destination
    window.location.assign(`/login?${params.toString()}`);
  };

  return (
    <WelcomePageWrapper>
      <Stack
        sx={{
          gap: '40px',
          overflow: 'hidden',
          width: '680px',
          maxWidth: '100%',
        }}
      >
        <Typography
          variant='h1'
          sx={{ maxWidth: '540px', wordWrap: 'break-word' }}
        >
          Log in with your account’s domain
        </Typography>
        <Stack direction='row' sx={{ alignItems: 'center', gap: '16px' }}>
          <DomainInput
            autoFocus
            focused={focused}
            onBlur={() => setFocused(false)}
            onFocus={() => setFocused(true)}
            slotProps={{ htmlInput: { 'data-testid': 'login-domain' } }}
            value={domain}
            sx={{ width: '308px' }}
            onChange={(e) => {
              const newValue = e.target.value;

              if (/^[a-zA-Z0-9-]*$/.test(newValue)) {
                setDomain(newValue);
              }
            }}
            onKeyUp={(event) => {
              if (event.key === 'Enter') {
                onLogin(domain);
              }
            }}
          />
          <Button
            className='h-full'
            disabled={!domain}
            data-testid='login-button'
            variant='contained'
            onClick={() => onLogin(domain)}
          >
            Log In
            <i className='material-symbols-arrow-right-alt ml-[8px] align-middle' />
          </Button>
        </Stack>
        <Divider
          sx={{
            borderStyle: 'dashed',
            borderColor: 'var(--mui-palette-divider)',
          }}
        />
        <Stack direction='row' sx={{ alignItems: 'center', gap: '8px' }}>
          <Typography>{`Don't have an account?`}</Typography>
          <Link
            className='font-bold no-underline'
            href='https://www.eon.io/get-a-demo'
            target='_blank'
          >
            Sign Up
          </Link>
        </Stack>
      </Stack>
    </WelcomePageWrapper>
  );
};
